import { render } from "./coordenadoresEditar.vue?vue&type=template&id=718b7ce2"
import script from "./coordenadoresEditar.vue?vue&type=script&lang=js"
export * from "./coordenadoresEditar.vue?vue&type=script&lang=js"

import "./coordenadoresEditar.vue?vue&type=style&index=0&id=718b7ce2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__